import type { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { default as moment, Moment } from 'moment';

export const ngbDateToMoment = (input: NgbDateStruct): Moment => {
  return moment({
    date: input.day,
    month: input.month - 1,
    year: input.year
  });
};

export const momentToNgbDate = (input: Moment): NgbDateStruct => {
  return {
    day: input.date(),
    month: input.month() + 1,
    year: input.year()
  };
};
